// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1iKpA","tab":"Tabs_tab__1qIP3","tabActive":"Tabs_tabActive__nkeCi"};